import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Service Area',
    href: '#service-area'
  }, {
    name: 'Weekly Maintenance',
    href: '#maintenance'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy shadow-lg py-2' : 'bg-transparent py-4'}`} data-id="element-111">
      <div className="container mx-auto px-6 flex items-center justify-between h-16 lg:h-20" data-id="element-112">
        {/* Logo */}
        <a href="#hero" className="flex items-center gap-3 z-50" data-id="element-113">
          <img src="https://cdn.magicpatterns.com/uploads/uVzrfAneKFyMB5qb1N8DUF/hanse-new-logo_redline_pool_tile.png" alt="Redline Pool Tile Restoration" className="h-12 w-12 lg:h-[76px] lg:w-[76px] object-contain bg-white rounded-full p-1" data-id="element-114" />
          <span className="text-white font-bold tracking-wider uppercase hidden sm:flex flex-col leading-tight text-sm lg:text-base" data-id="element-115">
            <span data-id="element-116">Redline Pool Tile</span>
            <span data-id="element-117">Restoration</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-118">
          <ul className="flex items-center gap-6" data-id="element-119">
            {navLinks.map(link => <li key={link.name} data-id="element-120">
                <a href={link.href} className="text-white hover:text-brand-red transition-colors font-medium text-sm uppercase tracking-wide" data-id="element-121">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="#contact" className="bg-brand-red hover:bg-brand-red-dark text-white px-6 py-2.5 rounded-lg font-bold transition-colors" data-id="element-122">
            Get a Free Quote
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white z-50 p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-123">
          {isMobileMenuOpen ? <XIcon size={28} data-id="element-124" /> : <MenuIcon size={28} data-id="element-125" />}
        </button>

        {/* Mobile Nav Overlay */}
        <div className={`fixed inset-0 bg-navy-dark flex flex-col items-center justify-center transition-transform duration-300 lg:hidden ${isMobileMenuOpen ? 'translate-y-0' : '-translate-y-full'}`} data-id="element-126">
          <ul className="flex flex-col items-center gap-5 text-center overflow-y-auto max-h-[80vh] py-4" data-id="element-127">
            {navLinks.map(link => <li key={link.name} data-id="element-128">
                <a href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-white text-xl font-bold uppercase tracking-wider hover:text-brand-red transition-colors min-h-[44px] flex items-center" data-id="element-129">
                  {link.name}
                </a>
              </li>)}
            <li data-id="element-130">
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="bg-brand-red hover:bg-brand-red-dark text-white px-8 py-4 rounded-lg font-bold text-xl transition-colors mt-4 inline-block w-full min-w-[250px]" data-id="element-131">
                Get a Free Quote
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>;
}